import { InventoryItemViewModel } from '../../inventory-items/inventoryItem';
import PropTypes from 'prop-types';
import React from 'react';
import { LinkButton } from '@ami/react/core';
import { appConfig } from '@ami/react/core';
import StockRunLeadTimeLabel from '../../quotes/lead-times/StockRunLeadTimeLabel';

const weightCategoriesList = (weightCategories) => (
  <ul className="list-unstyled mb-2 p-0">
    {weightCategories.map((wc) => (
      <li key={wc}>{wc}</li>
    ))}
  </ul>
);

const Availability = ({ inventoryItem }) => {
  if (inventoryItem.inStock) {
    if (inventoryItem.minimumLeadTime === 1) return 'Next day';
    return `${inventoryItem.minimumLeadTime} business days`;
  }

  return (
    <StockRunLeadTimeLabel
      availableOn={inventoryItem.availableOn}
      minimumNumberOfDays={inventoryItem.minimumLeadTime}
    />
  );
};

const Row = ({ inventoryItem, onOpenEdit }) => {
  const {
    id,
    notes,
    paintColor,
    dimensions,
    partNumber,
    availableQuantity,
    carrierName,
    condition,
    imageUrl,
    restrictedReason,
    lugging,
    thumb,
    isConsignment,
    consignmentDealerBranchName
  } = inventoryItem;

  const name = <strong>{inventoryItem.name}</strong>;
  const showEditLink = appConfig.isManagementApp;
  return (
    <tr>
      <td>
        <img
          src={imageUrl}
          className="img-fluid"
          alt={inventoryItem.name}
          style={{ maxWidth: 100 }}
        />
      </td>
      <td className="inventory-item-description">
        {showEditLink && (
          <LinkButton id={id} label={name} onClick={onOpenEdit.bind(id)} />
        )}
        {!showEditLink && name}
        <br />
        <div className="dimensions">
          {dimensions.map((dimension, idx) => (
            <div className="row" key={idx}>
              <div className="col-auto text-nowrap">{`${dimension.name}:`}</div>
              <div className="col-auto text-break-line">{dimension.value}</div>
            </div>
          ))}
        </div>
        {inventoryItem.productOptions.length > 0 && (
          <ul
            style={{
              listStyle: 'none',
              padding: 0,
              marginTop: 5,
              marginBottom: 0,
            }}
          >
            {inventoryItem.productOptions.map((x, idx) => (
              <li key={idx}>{x}</li>
            ))}
          </ul>
        )}
        {thumb && (
          <div
            className="dimensions"
            style={{
              listStyle: 'none',
              padding: 0,
              marginTop: 5,
              marginBottom: 0,
            }}
          >
            <div className="row">
              <div className="col-auto text-nowrap">Tip Radius:</div>
              <div className="col-auto text-break-line">{thumb.tipRadius}"</div>
            </div>
            <div className="row">
              <div className="col-auto text-nowrap">Thumb Class:</div>
              <div className="col-auto text-break-line">
                {thumb.thumbClassPartNumber || '--'}
              </div>
            </div>
            <div className="row">
              <div className="col-auto text-nowrap">Factory Mount:</div>
              <div className="col-auto text-break-line">
                {thumb.factoryMount ? 'Yes' : 'No'}
              </div>
            </div>
          </div>
        )}
        {paintColor && (
          <div className="row mt-2">
            <div className="col">Painted {paintColor}</div>
          </div>
        )}
        {notes && (
          <div className="row mt-2">
            <div className="col">{notes}</div>
          </div>
        )}
        {restrictedReason && (
          <div className="row mt-2">
            <div className="col">
              <span className="badge text-bg-danger p-1">
                {restrictedReason}
              </span>
            </div>
          </div>
        )}
        {isConsignment && (
          <div className="row mt-2">
            <div className="col">
              <div className="alert alert-info text-start p-2 mb-0">
                Consignment {consignmentDealerBranchName && <span> at {consignmentDealerBranchName}</span>}
            </div>
            </div>
          </div>
        )}
      </td>
      <td data-title="Compatibility">
        <div>{carrierName}</div>
        {weightCategoriesList(inventoryItem.weightCategoryLabels)}
        {lugging.pinUpName && (
          <div>
            {`Direct Pin On: ${lugging.pinUpName}`}
          </div>
        )}
        {lugging.couplerNames && lugging.couplerNames.length > 0 && (
          <div>
            <span>Lugging: </span>
            <span>
              {lugging.couplerNames.join(", ")}
            </span>
          </div>
        )}
      </td>
      <td data-title="Part Number">{partNumber}</td>
      <td data-title="Condition">
        {condition.charAt(0).toUpperCase() + condition.slice(1)}
      </td>
      <td data-title="Availability">
        {inventoryItem.sold ? (
          'Sold'
        ) : (
          <Availability inventoryItem={inventoryItem} />
        )}
      </td>
      <td data-title="Quantity">{availableQuantity}</td>
    </tr>
  );
};

Row.propTypes = {
  inventoryItem: PropTypes.instanceOf(InventoryItemViewModel).isRequired,
  onOpenEdit: PropTypes.func.isRequired,
};

export default Row;
